import { render } from "./EmployeeAccessProduct.vue?vue&type=template&id=5d652b93&scoped=true"
import script from "./EmployeeAccessProduct.vue?vue&type=script&lang=js"
export * from "./EmployeeAccessProduct.vue?vue&type=script&lang=js"

import "./EmployeeAccessProduct.vue?vue&type=style&index=0&id=5d652b93&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d652b93"],['__file',"src/views/h5/common/basedata/employee/employeeDataAccess/EmployeeAccessProduct.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d652b93"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d652b93', __exports__)) {
    api.reload('5d652b93', __exports__)
  }
  
  module.hot.accept("./EmployeeAccessProduct.vue?vue&type=template&id=5d652b93&scoped=true", () => {
    api.rerender('5d652b93', render)
  })

}


export default __exports__